import React, { PropTypes } from 'react';
import classnames from 'classnames';
import Thumbnail from 'common/components/thumbnail';

const PREVIEW_THUMBS = [
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/17/8d25f7be51ba42a09f77ed71237f1b11.jpg',
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/17/939c5ae32b73435fb69ad31f8e509c2f.jpg',
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/7c/a3a0a9781ae349b0a8152799da183f38.jpg',
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/8d/6a4620714c8f48a1b453276594b207de.jpg',
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/f2/45c49dbab96f4e0abd107c0435148bfc.jpg',
  'https://s3.amazonaws.com/crowdspring3-production/project_entries/07/e957d10ec39f4f738b0c657d64ead571.jpg'
];

const IntroPreview = ({ purpose, logo, primaryColor }) => {
  return (
    <div className="participant-preview intro-preview">
      <header style={{ backgroundColor: primaryColor }}>
        { logo && <div className="logo" style={{ backgroundImage: `url(${logo})` }} /> }
      </header>
      <div className="main-content">
        <div className="row">
          <div className="columns small-16 medium-12 medium-offset-2">
            <div className="text-center purpose">{ purpose }</div>
          </div>
        </div>
        <div className="row small-up-1 medium-up-4">
        { PREVIEW_THUMBS.map((thumbnailImage, i) => (
          <div key={i} className={classnames("columns small-16", { "hide-for-small-only": i > 0 })}>
            <div className="tile entry-tile">
              <Thumbnail className="entry-thumbnail" image={thumbnailImage} />
            </div>
          </div>
        )) }
        </div>
      </div>
    </div>
  );
}

IntroPreview.propTypes = {
  logo: PropTypes.string,
  primaryColor: PropTypes.string,
  purpose: PropTypes.string
};

export default IntroPreview;



// WEBPACK FOOTER //
// ./presentations/components/intro_preview.jsx